import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { api } from '../context/AuthContext';

export default function FeaturedProducts({ currentProductId }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFeaturedProducts();
  }, [currentProductId]);

  const loadFeaturedProducts = async () => {
    try {
      // Get all products and filter out current one, then pick 4 random
      const { data } = await api.get('/products?limit=50');
      let allProducts = data.products || [];
      
      // Filter out current product and active ones
      allProducts = allProducts.filter(p => 
        p.id !== currentProductId && 
        p.status === 'ACTIVE'
      );
      
      // Shuffle and take 4
      const shuffled = allProducts.sort(() => Math.random() - 0.5);
      setProducts(shuffled.slice(0, 4));
    } catch (err) {
      console.error('Error loading featured products:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="bg-white border rounded-xl p-4 animate-pulse">
            <div className="h-32 bg-gray-200 rounded-lg mb-3"></div>
            <div className="h-4 bg-gray-200 rounded mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-2/3"></div>
          </div>
        ))}
      </div>
    );
  }

  if (products.length === 0) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {products.map(product => (
        <Link 
          key={product.id} 
          to={`/products/${product.id}`}
          className="bg-white border rounded-xl overflow-hidden hover:shadow-lg transition group"
        >
          <div className="aspect-square bg-gray-100 overflow-hidden">
            {product.images?.[0]?.url ? (
              <img 
                src={product.images[0].url} 
                alt={product.title}
                className="w-full h-full object-cover group-hover:scale-105 transition"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                📦
              </div>
            )}
          </div>
          <div className="p-3">
            <h4 className="font-medium text-sm truncate">{product.title}</h4>
            <div className="flex items-center justify-between mt-2">
              <span className="font-bold text-primary">
                ₡{product.price?.toLocaleString()}
              </span>
              {product.avg_rating > 0 && (
                <div className="flex items-center gap-1 text-xs text-gray-500">
                  <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
                  {product.avg_rating.toFixed(1)}
                </div>
              )}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}